import { Component } from '@angular/core';
import { CommunicationDocumentDTO } from '../../../api/plyca-dtos-v2';
import { DocumentVersionDTO, DocumentDTO, I18nData, getParentIdentifierFromString } from '../../../api/plyca-dtos';
import { CommunicationBaseFieldComponent } from './communication.basefield.component';
import { documentsComponent } from '../../../documents/documents.component';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { documentViewerComponent } from '../../../documents/documentViewer/documentViewer.component';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';


@Component({
  selector: 'communication-field-docs',
  templateUrl: './communication.field-docs.template.html'
})
export class CommunicationFieldDocsComponent extends CommunicationBaseFieldComponent {

  public onRemoveDocument(event: { originalEvent: Event, value: any }): void {
    this.model.dto.documents = this.model.dto.documents.filter(doc => !CommunicationDocumentDTO.sameObject(doc, event.value));
  }

  public onAddDocument(event: { originalEvent: Event, value: any }) {
    console.log(event.value + ' added !!!');
  }

  public onDocumentClick(commDoc: CommunicationDocumentDTO): void {
    // let commDoc = event.value as CommunicationDocumentDTO;
    let config: DynamicDialogConfig = {
      header: commDoc.document.entity.documentClass.name,
      width: '97%',
      styleClass: 'helpStyle'
    };
    if (commDoc) {
      let docVersion = commDoc.documentVersion as DocumentVersionDTO;
      if (docVersion && docVersion.versionNumber) {
        config.data = {
          'id': (commDoc.document && commDoc.document.identifier) ?
            commDoc.document.identifier : getParentIdentifierFromString(commDoc.documentVersion.identifier),
          'version': commDoc.documentVersion.versionNumber
        }
        this.editDialogOpened.emit(true);
        let ref = this.dialogService.open(documentViewerComponent, config);
        this.subscribe(ref.onClose,
          () => this.editDialogOpened.emit(false),
          (error) => {
            this.editDialogOpened.emit(false);
            throw error;
          }
        );
      }
    }
  }

  public cancelKeyPressed(event: KeyboardEvent) {
    // permitir backspace y delete
    if (!(event.keyCode === 8 || event.keyCode === 46)) {
      return this.uiService.cancelEvent(event);
    }
  }

  public searchDocuments(): void {
    let config: DynamicDialogConfig = {
      header: '',
      width: '80%',
      styleClass: 'helpStyle'
    };
    config['id'] = this.model.dto.project.identifier;
    // establecer filtros
    let docQueryFilter = {
      avoidTemporaryDocs: true
    }
    config['docFilters'] = docQueryFilter;
    config['selectionMode'] = true;
    this.editDialogOpened.emit(true);
    let ref = this.dialogService.open(documentsComponent, config);
    this.subscribe(ref.onClose,
      (documentresult: DocumentDTO) => {
        if (documentresult) {
          console.log('document selected', documentresult);
          let commDocs = this.model.dto.documents;
          // definicion del nuevo documento
          let newDoc = new CommunicationDocumentDTO();
          newDoc.document = documentresult;
          let docVersionNumberObs: Observable<DocumentVersionDTO>;
          if (documentresult.currentVersion && documentresult.currentVersion.files && documentresult.currentVersion.files.length > 0) {
            docVersionNumberObs = of(documentresult.currentVersion);
          } else {
            docVersionNumberObs = this.plycaService.get<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL,
              documentresult.identifier,
              { expand: 'currentVersion' })
              .pipe(
                map((doc: DocumentDTO) => doc.currentVersion)
              );
          }
          this.subscribe(docVersionNumberObs,
            (docVersion: DocumentVersionDTO) => {
              // establecer version asociada al documento
              newDoc.versionNumber = docVersion.versionNumber;
              newDoc.documentVersion = docVersion
              let add = true;
              if (!commDocs) {
                commDocs = [];
                this.model.dto.documents = commDocs;
              } else {
                // comprobar que el documento no se ha añadido anteriormente
                add = commDocs.find(doc => CommunicationDocumentDTO.sameObject(doc, newDoc)) == undefined;
              }
              if (add) {

                commDocs.push(newDoc);
                // Se enfoca el elemento y se provoca el evento click para que se actualize el campo
                let docsInput = document.getElementById('commdocsid');
                if (docsInput) {
                  docsInput.focus();
                  docsInput.click();
                }

              } else {
                this.uiService.showMessage(new I18nData('Communications.detail.form.errors.docExists'), 'General.warning');
              }
              this.editDialogOpened.emit(false);
            });
        } else {
          this.editDialogOpened.emit(false);
        }
      },
      (error) => {
        this.editDialogOpened.emit(false);
        throw error;
      }
    );
  }


}